<template>
  <div>
    <apexchart
      class="print:hidden"
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
      ref="barChart"
      @updated="onChartUpdated"
    ></apexchart>
    <img class="print:block hidden" :src="imgURI" alt="" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("whiteLabel");

export default {
  data() {
    return {
      primaryLoaded: false,
      secondaryLoaded: false,
      imgURI: null,
      series: [
        {
          name: "Primary",
          data: [0, 0, 0, 0, 0]
        },
        {
          name: "Secondary",
          data: [0, 0, 0, 0, 0]
        }
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false
          }
        },
        colors: ["#7DBE3B", "#0CADD8"],
        grid: {
          show: false
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "75%"
            //endingShape: "rounded"
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(value) {
            return value.toLocaleString();
          }
        },
        legend: {
          fontFamily: "PT Sans",
          fontWeight: 700,
          fontSize: "20px",
          labels: {
            colors: ["#4a5568"]
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          labels: {
            formatter: function(value) {
              return value.toLocaleString();
            },
            style: {
              fontFamily: "PT Sans",
              fontWeight: 700,
              fontSize: "14px",
              colors: "#4a5568"
            }
          },
          title: {
            text: "Years Old",
            style: {
              fontFamily: "PT Sans",
              fontWeight: 700,
              fontSize: "16px",
              color: "#a0aec0"
            }
          },
          categories: ["20-30", "30-40", "40-50", "50-60", "60+"]
        },
        yaxis: {
          title: {
            text: "People",
            style: {
              fontFamily: "PT Sans",
              fontWeight: 700,
              fontSize: "16px",
              color: "#a0aec0"
            }
          },
          labels: {
            formatter: function(value) {
              return value.toLocaleString();
            },
            style: {
              fontFamily: "PT Sans",
              fontWeight: 700,
              fontSize: "14px",
              colors: "#4a5568"
            }
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val.toLocaleString() + " people";
            }
          }
        }
      }
    };
  },
  props: {
    location: {
      type: Object,
      required: true
    },
    primaryRadius: {
      type: Number,
      required: true
    },
    secondaryRadius: {
      type: Number,
      required: true
    }
  },
  async created() {
    await this.updatePrimary();
    await this.updateSecondary();
    this.setThemeColors();
  },
  computed: {
    ...mapGetters(["primaryColor", "secondaryColor"])
  },
  methods: {
    setThemeColors() {
      this.chartOptions.colors[0] = this.primaryColor;
      this.chartOptions.colors[1] = this.secondaryColor;
    },
    async updatePrimary() {
      this.$http
        .post(
          "/reach-estimates/ages",
          {
            latitude: this.location.lat,
            longitude: this.location.lng,
            /* eslint-disable */
          targeting_radius: this.primaryRadius
            /* eslint-enable */
          },
          { retry: 5, retryDelay: 250 }
        )
        .then(response => {
          this.series[0].data = [];
          response.data.forEach(element => {
            this.series[0].data.push(element.users);
          });
          this.$refs.barChart.updateSeries(this.series, true);
          this.primaryLoaded = true;
          this.checkLoading();
        })
        .catch(error => {
          console.log(error);
        });
    },
    async updateSecondary() {
      this.$http
        .post(
          "/reach-estimates/ages",
          {
            latitude: this.location.lat,
            longitude: this.location.lng,
          /* eslint-disable */
          targeting_radius: this.secondaryRadius
            /* eslint-enable */
          },
          { retry: 5, retryDelay: 250 }
        )
        .then(response => {
          this.series[1].data = [];
          response.data.forEach(element => {
            this.series[1].data.push(element.users);
          });
          this.$refs.barChart.updateSeries(this.series, true);
          this.secondaryLoaded = true;
          this.checkLoading();
        })
        .catch(error => {
          console.log(error);
        });
    },
    checkLoading() {
      if (this.primaryLoaded && this.secondaryLoaded) {
        this.$emit("loaded");
      }
    },
    onChartUpdated() {
      this.$refs.barChart.dataURI().then(({ imgURI }) => {
        this.imgURI = imgURI;
      });
    }
  }
};
</script>
